import {
    Box,
    FormControlLabel,
    MenuItem,
    Radio,
    Typography,
    withStyles,
} from '@material-ui/core';
import CustomSwitch from '../../../../components/Switch';
import { Autocomplete } from '@material-ui/lab';
import { CustomTextField } from '../../../../components/Textfield';

export const StyledMenuItem = withStyles((theme) => ({
    root: {
        margin: '0 8px',
        border: '0 !important',
        borderRadius: '8px',
        '&:hover': {
            backgroundColor: 'rgba(67, 65, 158, 0.08)',
            color: '#43419e',
            borderRadius: '8px',
        },
    },
}))(MenuItem);

export const LabeledSwitch = ({ title, icon, ...props }) => {
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '16px',
            }}
        >
            <Typography
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: '#14112d',
                }}
            >
                {icon}
                {title}
            </Typography>
            <CustomSwitch {...props} />
        </Box>
    );
};

export const StyledAutocomplete = withStyles(() => ({
    root: {
        width: '100%',
        '& .MuiOutlinedInput-notchedOutline': {
            borderTop: 0,
            borderRadius: 0,
            borderWidth: 0,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
        },
        '& .MuiChip-root': {
            backgroundColor: '#EBEBEB',
            // border: '1px solid #e4e4e4',
        },
        '& .MuiChip-label': {
            fontWeight: 600,
        },
    },
    popper: {
        '& .MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: '#fff',
        },
    },
}))(Autocomplete);

export const StyledCustomTextField = withStyles(() => ({
    root: {
        width: '100%',
        '& .MuiOutlinedInput-notchedOutline': {
            borderTop: 0,
            borderRadius: 0,
            borderWidth: 0,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
        },
        '& .MuiChip-root': {
            backgroundColor: '#EBEBEB',
            // border: '1px solid #e4e4e4',
        },
        '& .MuiChip-label': {
            fontWeight: 600,
        },
    },
    popper: {
        '& .MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: '#fff',
        },
    },
}))(CustomTextField);

export const RadioButton = withStyles({
    root: {
        width: '24%',
        border: 'solid 1px rgba(0, 0, 0, 0.23)',
        borderRadius: '8px',
        marginTop: 10,
        marginRight: 0,
        '&$checked': {
            border: 'solid 1px #43419e',
        },
    },
})((props) => (
    <FormControlLabel control={<Radio color="primary" />} {...props} />
));

export const HubSelector = ({
    hub,
    hubs,
    onHubSelect,
    workTabHubNShiftList,
    error,
    helperText,
}) => (
    <StyledCustomTextField
        label="Hub Name"
        select
        fullWidth={true}
        value={hub?.hubId ?? ''}
        isRequired={true}
        onChange={onHubSelect}
        defaultValue=""
        style={{
            width: '100%',
            marginRight: 5,
            borderTop: 0,
            borderRadius: 0,
            borderWidth: 0,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
        }}
        displayEmpty={true}
        error={error}
        helperText={helperText}
    >
        {hubs?.length ? (
            hubs.map((hub, index) => (
                <StyledMenuItem
                    key={index}
                    value={hub.id}
                    disabled={
                        !!workTabHubNShiftList?.find(
                            (i) => i?.hubId === hub?.id,
                        )
                    }
                >
                    {hub.name}
                </StyledMenuItem>
            ))
        ) : (
            <StyledMenuItem value={''}>No hub found</StyledMenuItem>
        )}
    </StyledCustomTextField>
);
